document.addEventListener("DOMContentLoaded", function() {
    // Target the <select> element by its id or class
    var selectElement = document.querySelector('select[name="options[Pet food flavor]"]');

    // Ensure the select element exists before proceeding
    if (selectElement) {
        // Get all <option> elements inside the select dropdown
        var options = selectElement.querySelectorAll('option');

        // Loop through each <option> and check if its text contains " - Unavailable"
        options.forEach(function(option) {
            if (option.textContent.includes(' - Unavailable')) {
                option.classList.add('d-none');  // Add the class 'd-none' to hide it
            }
        });
    } else {
        console.log("Select element not found");
    }
});
